import {
    FileSuggestion,
    FileSuggestionImmersiveViewSupported,
} from 'owa-search-service/lib/data/schema/SuggestionSet';
import { getFileSuggestionImmersiveViewSupported } from '../actions/getFileSuggestionImmersiveViewSupported';

export default function getIsFileImmersiveViewSupported(suggestion: FileSuggestion): boolean {
    if (!suggestion.ImmersiveViewSupported) {
        getFileSuggestionImmersiveViewSupported(suggestion);
    }

    return suggestion.ImmersiveViewSupported === FileSuggestionImmersiveViewSupported.Supported;
}
